import React, {
  useState,
} from "react";

import {
  useNavigate,
} from "react-router";

import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import {
  MdKeyboardArrowDown,
} from "react-icons/md";

import logo from "../../assets/images/logo.svg";
import notificationIcon from "../../assets/images/header-notification.svg";
import userIcon from "../../assets/images/header-user.svg";

import "./Header.css";

const Header = ({
  hideLoginButton = false,
}) => {
  const navigate = useNavigate();

  const [
    accountAnchor,
    setAccountAnchor,
  ] = useState(null);

  const [
    notificationAnchor,
    setNotificationAnchor,
  ] = useState(null);

  const userType =
    localStorage.getItem("userType");

  const userName =
    localStorage
      .getItem("userName")
      ?.trim() || "المستخدم";

  const accountMenuOpen =
    Boolean(accountAnchor);

  const notificationMenuOpen =
    Boolean(notificationAnchor);

  const handleOpenAccountMenu = (
    event
  ) => {
    setNotificationAnchor(null);
    setAccountAnchor(
      event.currentTarget
    );
  };

  const handleCloseAccountMenu = () => {
    setAccountAnchor(null);
  };

  const handleOpenNotificationMenu = (
    event
  ) => {
    setAccountAnchor(null);

    setNotificationAnchor(
      event.currentTarget
    );
  };

  const handleCloseNotificationMenu =
    () => {
      setNotificationAnchor(null);
    };

  const handleDashboard = () => {
    handleCloseAccountMenu();

    if (userType === "Business") {
      navigate("/business/dashboard");
      return;
    }

    if (userType === "Internal") {
      navigate("/system/dashboard");
      return;
    }

    if (userType === "Customer") {
      navigate("/customer/dashboard");
    }
  };

  const handleLogout = () => {
    handleCloseAccountMenu();

    localStorage.clear();

    navigate("/", {
      replace: true,
    });
  };

  return (
    <header className="dga-header">
      <div className="dga-header__inner">
        <div className="dga-header__brand">
          <img
            className="dga-header__logo"
            src={logo}
            alt="صندوق تنمية الموارد البشرية"
          />
        </div>

        {!hideLoginButton && (
          <div className="dga-header__actions">
            {/* <button
              type="button"
              id="dga-notification-button"
              className="dga-header__notification"
              onClick={
                handleOpenNotificationMenu
              }
              aria-label="الإشعارات"
              aria-controls={
                notificationMenuOpen
                  ? "dga-notification-menu"
                  : undefined
              }
              aria-haspopup="true"
              aria-expanded={
                notificationMenuOpen
                  ? "true"
                  : undefined
              }
            >
              <img
                src={notificationIcon}
                alt=""
                aria-hidden="true"
              />

              <span
                className="dga-header__notification-dot"
                aria-hidden="true"
              />
            </button>

            <Menu
              id="dga-notification-menu"
              anchorEl={
                notificationAnchor
              }
              open={
                notificationMenuOpen
              }
              onClose={
                handleCloseNotificationMenu
              }
              MenuListProps={{
                "aria-labelledby":
                  "dga-notification-button",
                className:
                  "dga-notification-menu__list",
              }}
              slotProps={{
                paper: {
                  className:
                    "dga-notification-menu",
                },
              }}
              anchorOrigin={{
                horizontal: "center",
                vertical: "bottom",
              }}
              transformOrigin={{
                horizontal: "center",
                vertical: "top",
              }}
            >
              <div
                className="dga-notification-menu__empty"
                role="status"
              >
                لا توجد بيانات
              </div>
            </Menu> */}

            <Button
              id="dga-account-button"
              className="dga-header__account"
              onClick={
                handleOpenAccountMenu
              }
              disableRipple
              aria-controls={
                accountMenuOpen
                  ? "dga-account-menu"
                  : undefined
              }
              aria-haspopup="true"
              aria-expanded={
                accountMenuOpen
                  ? "true"
                  : undefined
              }
            >
              <span
                className="dga-header__account-icon"
                aria-hidden="true"
              >
                <img
                  src={userIcon}
                  alt=""
                />
              </span>

              <span
                className="dga-header__account-name"
                title={userName}
              >
                {userName}
              </span>

              <MdKeyboardArrowDown
                className="dga-header__account-arrow"
                aria-hidden="true"
              />
            </Button>

            <Menu
              id="dga-account-menu"
              anchorEl={accountAnchor}
              open={accountMenuOpen}
              onClose={
                handleCloseAccountMenu
              }
              MenuListProps={{
                "aria-labelledby":
                  "dga-account-button",
                className:
                  "dga-account-menu__list",
              }}
              slotProps={{
                paper: {
                  className:
                    "dga-account-menu",
                },
              }}
              transformOrigin={{
                horizontal: "left",
                vertical: "top",
              }}
              anchorOrigin={{
                horizontal: "left",
                vertical: "bottom",
              }}
            >
              <MenuItem
                className="dga-account-menu__item"
                onClick={
                  handleDashboard
                }
                disableRipple
              >
                <span>
                  لوحة القيادة
                </span>
              </MenuItem>

              <Divider className="dga-account-menu__divider" />

              <MenuItem
                className="dga-account-menu__item dga-account-menu__logout"
                onClick={handleLogout}
                disableRipple
              >
                <span>
                  تسجيل الخروج
                </span>
              </MenuItem>
            </Menu>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;